export default __webpack_public_path__ + "img/fqloliSW.fae1caee.svg";